import styled from 'styled-components'

function BaseKeyboardArrowRightIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" fill="currentColor" />
    </svg>
  )
}

export const KeyboardArrowRightIcon = styled(BaseKeyboardArrowRightIcon)`
  flex-shrink: 0;
`
